import { IBridgeApplicationGridRecord } from '@apply/api/src/api/applicationApi';

// The Incomplete tab's title, with a red count bubble in front of the text for the incomplete apps updated within the
// last business day (hidden when there are none). `tab` is the tab item DevExtreme passes to tabRender, so the text is
// the Item's own `title` (defined once, where the tab is declared).
export const incompleteTabRender = (tab: { title?: string }, incompleteApps: IBridgeApplicationGridRecord[] | undefined) => {
    /** Midnight at the start of the previous business day (Mon -> Fri, Sat/Sun -> Fri, otherwise yesterday), local time. */
    const getPreviousBusinessDayStart = (now: Date) => {
        const start = new Date(now.getFullYear(), now.getMonth(), now.getDate());
        const daysBack = start.getDay() === 1 ? 3 : start.getDay() === 0 ? 2 : 1;
        start.setDate(start.getDate() - daysBack);
        return start;
    };

    const since = getPreviousBusinessDayStart(new Date());
    const recentCount = incompleteApps?.filter((app) => new Date(app.lastUpdated) >= since).length ?? 0;

    return (
        <span className='bridgeApplicationsTabs-title'>
            {recentCount > 0 && (
                <span className='bridgeApplicationsTabs-badge'>
                    {recentCount > 9 ? (
                        // "9+" gets an optical nudge to look centred; single digits are centred as-is
                        <span className='bridgeApplicationsTabs-badgeText overflow'>9+</span>
                    ) : (
                        recentCount
                    )}
                </span>
            )}
            {tab.title}
        </span>
    );
};
